module.exports = __webpack_public_path__ + "static/media/logoImagine.a78e5985.png";